<template>
  <div class="profile">

    <!-- START Profile -->
    <div class="row">
      <div class="col-lg-6">
        <div class="card shadow">
          <div class="card-body">
            <card-title icon-image="mdi-content-paste" title="Profile" text-color="title" />

            <div class="row mt-2" id="datatable_wrapper">
              <div class="col-lg-12">
                <div class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input v-model="filter"
                                  type="search"
                                  placeholder="Search..."
                                  class="form-control form-control-sm ms-2" />
                  </label>
                </div>
              </div>
            </div>

            <div class="profile-table">
              <b-table class="datatables text-nowrap" hover
                       :fields="fields" :items="items"
                       :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc"
                       :filter="filter"
                       :filter-included-fields="filterOn"
                       @row-clicked="profileView"
                       @row-dblclicked="showModal('edit', item)">
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>

            <div class="row mt-2">
              <div class="col-lg-12 text-align-end">
                <b-button class="w-sm" size="sm" variant="primary" @click="showModal('create', null)">
                  <i class="fas fa-plus icon-padding-right ct-mb-padding-left-25" />
                  <span>Register</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card card-height-100 shadow">
          <div class="card-body">
            <card-title icon-image="mdi-database" title="Profile Data" text-color="title" />

            <div class="profile-data-table">
              <table class="table table-bordered mb-0">
                <thead>
                <tr>
                  <th scope="col" class="w-50">Item</th>
                  <th scope="col" class="w-50">Value</th>
                </tr>
                </thead>
                <tbody v-if="$_utils.isEmpty(item.chargingProfilePk)">
                <tr>
                  <td class="text-nowrap" scope="row" colspan="2">Profile 을 선택하세요.</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr v-for="it in jqlApi.schema" v-if="!$_utils.isEmpty(it.key)">
                  <th class="text-nowrap" scope="row">{{ it.label }}</th>
                  <td>{{ item[it.key] }}</td>
                </tr>

                <template v-if="item.chargingSchedulePeriod.length>0">
                  <tr>
                    <td colspan="2" style="text-align: left; padding-top: 20px">
                      <card-title icon-image="mdi-database" title="Schedule Period Data" text-color="title" />
                      <table class="profile-period-table">
                        <thead>
                        <tr>
                          <th>ID</th>
                          <th>Start Period In Seconds</th>
                          <th>Power Limit</th>
                          <th>Number Phases</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(it, i) in item.chargingSchedulePeriod" :class="{'last-tr':i==='3'}">
                          <td>{{ it.id }}</td>
                          <td>{{ it.startPeriodInSeconds }}</td>
                          <td>{{ it.powerLimit }}</td>
                          <td>{{ it.numberPhases }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Profile -->

    <!-- START Profile Modal -->
    <b-modal v-model="profileModal" centered header-bg-variant="primary" size="xl">
      <template #modal-header>
        <div class="text-white">Profile {{ mode === 'create' ? 'Registration' : 'Edit' }}</div>
      </template>
      <div class="row">
        <div class="col-lg-6">
          <div class="card">
            <div class="card-body">
              <card-title icon-image="mdi-content-paste" title="Profile" text-color="title" />
              <div class="row mt-3">

                <div class="col-lg-12">
                  <div class="mb-3">
                    <label for="profile-name-input" class="form-label">
                      <span>Profile Name</span><span class="text-danger ct-padding-left-25">*</span>
                    </label>
                    <b-form-input type="text" id="stack-level-input" v-model="form.profileName" />
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="stack-level-input" class="form-label">
                      <span>Stack Level</span><span class="text-danger ct-padding-left-25">*</span>
                    </label>
                    <b-form-input type="number" id="stack-level-input" v-model="form.stackLevel" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="profile-purpose-input" class="form-label">
                      <span>Charging Profile Purpose</span><span class="text-danger ct-padding-left-25">*</span>
                    </label>
                    <b-form-select class="form-select" id="profile-purpose-input"
                                   v-model="form.chargingProfilePurpose" :options="purposeOptions" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="profile-kind-input" class="form-label">
                      <span>Charging Profile Kind</span><span class="text-danger ct-padding-left-25">*</span>
                    </label>
                    <b-form-select class="form-select" id="profile-kind-input"
                                   v-model="form.chargingProfileKind" :options="kindOptions" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="recurrency-kind-input" class="form-label">Recurrency Kind</label>
                    <b-form-select class="form-select" id="recurrency-kind-input"
                                   v-model="form.recurrencyKind" :options="rKindOptions" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="valid-from-date" class="form-label">Valid From</label>
                    <date-picker type="datetime" id="valid-from-date" lang="ko"
                                 v-model="form.validFrom"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="valid-to-date" class="form-label">Valid To</label>
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.validTo"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="duration-in-seconds-input" class="form-label">Duration In Seconds</label>
                    <b-form-input type="number" id="duration-in-seconds-input" v-model="form.durationInSeconds" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="start-schedule-date" class="form-label">Start Schedule</label>
                    <date-picker type="datetime" id="start-schedule-date" lang="ko"
                                 v-model="form.startSchedule"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="charging-rate-unit-input" class="form-label">
                      <span>Charging Rate Unit</span><span class="text-danger ct-padding-left-25">*</span>
                    </label>
                    <b-form-select class="form-select" id="charging-rate-unit-input"
                                   v-model="form.chargingRateUnit" :options="rateUnitOptions" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="min-charging-rate-input" class="form-label">Min Charging Rate</label>
                    <b-form-input type="number" id="min-charging-rate-input" v-model="form.minChargingRate" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <label for="description-input" class="form-label">Description</label>
                  <b-form-textarea id="description-input" v-model="form.description" rows="3" max-rows="3" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card card-height-100">
            <div class="card-body">
              <card-title icon-image="mdi-content-paste" title="Schedule Period" text-color="title" />
              <div class="row" v-for="(item, i) in form.chargingSchedulePeriod">
                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="start-period-input" class="form-label">
                      <span>Start Period</span><span class="text-danger ct-padding-left-25">*</span>
                    </label>
                    <b-form-input type="number" id="start-period-input" v-model="item.startPeriodInSeconds" />
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="power-limit-input" class="form-label">
                      <span>Power Limit</span><span class="text-danger ct-padding-left-25">*</span>
                    </label>
                    <b-form-input type="number" id="power-limit-input" v-model="item.powerLimit" />
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="number-phases-input" class="form-label">Number Phases</label>
                    <b-form-input type="number" id="number-phases-input" v-model="item.numberPhases" />
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="mb-3">
                    <div style="padding-top: 34px">
                      <b-button size="xs" variant="outline-primary" class="btn-sm me-2"
                                v-if="form.chargingSchedulePeriod.length-1 === i"
                                @click="add(form.chargingSchedulePeriod, i)">add</b-button>
                      <b-button size="xs" variant="outline-danger" class="btn-sm"
                                v-if="i !== 0"
                                @click="del(form.chargingSchedulePeriod, i)">del</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-align-end">
          <b-button class="w-sm ct-margin-right-100" size="sm" variant="secondary" @click="profileModal = false">
            <i class="fas fa-times icon-padding-right ct-mb-padding-left-25" />
            <span class="d-none d-sm-inline-block">Close</span>
          </b-button>
          <b-button class="w-sm" size="sm" variant="primary" @click="save()">
            <i class="fas fa-plus icon-padding-right ct-mb-padding-left-25" />
            <span>Save</span>
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- END Profile Modal -->

  </div>
</template>

<script>
import CardTitle from '@/views/components/cardTitle.vue';

export default {
  components: { CardTitle },
  data() {
    const _api = this.$_app.service.chargingProfile
    return {
      jqlApi: _api,
      mode: null,
      profileModal: false,
      showTimePanel: false,
      filter: null,
      filterOn: [],
      sortBy: 'chargingProfilePk',
      sortDesc: true,
      fields: [
        { key: 'no', label: 'No.' },
        { key: 'chargingProfilePk', label: 'ID', sortable: true },
        { key: 'profileName', label: 'Name', sortable: true },
        { key: 'chargingProfilePurpose', label: 'Purpose', sortable: true },
        { key: 'chargingProfileKind', label: 'Kind', sortable: true }
      ],
      items: [],
      selectedRow: null,
      item: {},
      form: {
        profileName: null,
        stackLevel: null,
        chargingProfilePurpose: null,
        chargingProfileKind: null,
        recurrencyKind: null,
        validFrom: null,
        validTo: null,
        durationInSeconds: null,
        startSchedule: null,
        chargingRateUnit: null,
        minChargingRate: null,
        description: null,
        chargingSchedulePeriod: []
      },
      purposeOptions: [
        { value: 'ChargePointMaxProfile', text: 'ChargePointMaxProfile'},
        { value: 'TxProfile', text: 'TxProfile'},
        { value: 'TxDefaultProfile', text: 'TxDefaultProfile'}
      ],
      kindOptions: [
        { value: 'Relative', text: 'Relative'},
        { value: 'Recurring', text: 'Recurring'},
        { value: 'Absolute', text: 'Absolute'}
      ],
      rKindOptions: [
        { value: 'Weekly', text: 'Weekly'},
        { value: 'Daily', text: 'Daily'}
      ],
      rateUnitOptions: [
        { value: 'W', text: 'W'},
        { value: 'A', text: 'A'}
      ]
    }
  },
  mounted() {
    const vm = this;

    vm.getItems();
  },
  methods: {
    setPeriod() {
      const vm = this;

      if (vm.form.chargingSchedulePeriod.length === 0) {
        vm.form.chargingSchedulePeriod.push({
          startPeriodInSeconds: null,
          powerLimit: null,
          numberPhases: null
        })
      }
    },
    reset() {
      const vm = this;

      vm.form = {
        stackLevel: null,
        chargingProfilePurpose: null,
        chargingProfileKind: null,
        recurrencyKind: null,
        validFrom: null,
        validTo: null,
        durationInSeconds: null,
        startSchedule: null,
        chargingRateUnit: null,
        minChargingRate: null,
        description: null,
        chargingSchedulePeriod: []
      }
    },
    getItems() {
      const vm = this;

      vm.jqlApi.list()
          .then(res => {
            vm.items = res;
          }).catch(err => {
            console.log(err);
          });
    },
    profileView(row) {
      const vm = this;
      vm.selectedRow = row;

      vm.jqlApi.findById(vm.selectedRow.chargingProfilePk)
          .then(res => {
            vm.item = Object.assign({}, res);
          }).catch(err => {
            console.log(err)
          });
    },
    showModal(mode, row) {
      const vm = this;
      vm.reset();

      vm.mode = mode;
      vm.profileModal = true;

      if (mode === 'edit') {
        vm.selectedRow = row;
        vm.form = Object.assign({}, vm.selectedRow);
      }

      vm.setPeriod();
    },
    handleOpenChange() {
      const vm = this;
      vm.showTimePanel = false;
    },
    toggleTimePanel() {
      const vm = this;
      vm.showTimePanel = !vm.showTimePanel;
    },
    add(target, index) {
      target.splice(index + 1, 0, {
        startPeriodInSeconds: null,
        powerLimit: null,
        numberPhases: null
      });
    },
    del(target, index) {
      target.splice(index, 1);
    },
    save() {
      const vm = this;
      const entity = vm.form;

      if (vm.mode === 'create') {
        vm.jqlApi.add(entity)
            .then(res => {
              vm.profileModal = false;
              this.$swal('등록 완료', '등록이 완료되었습니다.', 'success')
              vm.getItems();
            }).catch(err => {
              console.log(err)
              this.$swal('등록 실패', '등록에 실패하였습니다.', 'error')
            });
      } else if (vm.mode === 'edit') {
        vm.jqlApi.updateByIdList(vm.selectedRow.chargingProfilePk, entity)
            .then(res => {
              vm.profileModal = false;
              this.$swal('수정 완료', '수정이 완료되었습니다.', 'success')
              vm.getItems();
              vm.profileView(vm.selectedRow);
            }).catch(err => {
              console.log(err)
              this.$swal('수정 실패', '수정에 실패하였습니다.', 'error')
            });
      }
    }
  }
}
</script>
